const selectClaudeAnswer = state => state.claude.items || [];

const selectRequestStatus = state => state.claude.status;


export default {
  selectClaudeAnswer,
  selectRequestStatus,
};
